

export const BASE_URL = `${window.location.protocol}//kehav.technanosoft.com`
// export const UserName = '22dhj5823sdf'
// export const Password = 'shfdhHsdf9IUd095357dsJdfmkqffd43'

export const UserName = '22dhj5823sdf'
export const Password = 'shfdhHsdf9IUd095357dsJdfmkqffd43'

export const LOGIN_URl = 'api/user/login';
export const USER_INFO_URl = 'api/user/profile';
export const ADMIN_PROFILE_UPDATE = 'api/user/update-profile-image-from-admin';
export const USER_PROFILE_UPDATE = 'api/user/update-profile-image';


// dashbioard  -----
export const DASHBOARD_ANALYTICS_URL = 'api/dashboard/analytics'



//role -------
export const Role_URl = 'api/roles/all';
export const SINGLE_Role_URl = 'api/roles/get';
export const CREATE_Role_URl = 'api/roles/create';
export const Update_Role_URl = 'api/roles/update';
export const Delete_Role_URl = 'api/roles/delete';

// user -----------
export const CREATE_USERS_URl = 'api/user/register';
export const UPDATE_USERS_URl = 'api/user/update-with-password';
export const GET_USERS_URl = 'api/user/get-all-users';
export const GET_USER_URl = 'api/user/get-user';
export const DELETE_USERS_URl = 'api/user/delete-user';


// mnue -------------
export const GET_MENU_URl = 'api/menu-master/all';
export const GET_PARENT_MENU_URl = 'api/menu-master/parent-menus';
export const GET_SINGLE_MENu_URl = 'api/menu-master/all';
export const CREATE_MENU_URl = 'api/menu-master/create';
export const UPDATE_MENU_URl = 'api/menu-master/update';
export const DELETE_MENU_URl = 'api/menu-master/delete';
export const ASSIGN_MENU_BY_ROLE = 'api/role-menu-permission/assign';
export const GET_MENU_BY_ROLE_URl = 'api/role-menu-permission/get-by-role';



// ------ product 
export const GET_PRODUCTS_URl = 'api/product/all';
export const CREATE_PRODUCT_URl = 'api/product/create';
export const UPDATE_PRODUCT_URl = 'api/product/update';
export const DELETE_PRODUCT_URl = 'api/product/delete';


// ------ call-disposition 
export const GET_Call_DISPOSITION_URl = 'api/call-disposition-master/all';
export const CREATE_Call_DISPOSITION_URl = 'api/call-disposition-master/create';
export const UPDATE_Call_DISPOSITION_URl = 'api/call-disposition-master/update';
export const DELETE_Call_DISPOSITION_URl = 'api/call-disposition-master/delete';

// calls ----------
export const GET_Calls_URl = 'api/calls-manage/all';
export const CREATE_CALL_URl = 'api/calls-manage/create';
export const UPDATE_CALL_URl = 'api/calls-manage/update';
export const DELETE_CALL_URl = 'api/calls-manage/delete';
export const GET_Calls_HISTORY_URl = 'api/calls-manage/history';
export const MANAGE_Calls_VIEW_HISTORY_LOG_URl = 'api/calls-manage-view-history/log-view';
export const MANAGE_Calls_VIEW_HISTORY_URl = 'api/calls-manage-view-history/viewers';

//call manage column permisson --
export const CALLS_MANAGE_COLUMN_PERMISSON_SET_URL = 'api/calls-manage-column-permission/set'; //note use
export const CALLS_MANAGE_COLUMN_PERMISSON_GET_URL = 'api/calls-manage-column-permission/get'; //note use

// calls ----------
//call manage column permisson --
export const CREATE_OPERATING_URl = 'api/operating-system-master/create';
export const GET_OPERATING_URl = 'api/operating-system-master/all';
export const UPDATE_OPERATING_URl = 'api/operating-system-master/update';
export const DELETE_OPERATING_URl = 'api/operating-system-master/delete';


export const GET_ALL_CUSTOMER = 'api/customer/all';
export const CREATE_CUSTOMER = 'api/customer/create';
export const UPDATE_CUSTOMER = 'api/customer/update';
export const DELETE_CUSTOMER = 'api/customer/delete';
export const GET_CUSTOMER_BY_NUMBER = 'api/customer/get-by-number';
export const GET_CUSTOMER_BY_ID = 'api/customer/get-by-id';
export const CUSTOMER_HISTORY = 'api/customer/change-history';
export const CREATE_CUSTOMER_VIEW_LOG = 'api/customers-view-history/log-view';
export const VIEWERS_HISTORY = 'api/customers-view-history/viewers';
export const UPLOAD_FILE = 'api/customer/upload-file';
export const ASSIGN_CUSTMER = 'api/customer/assign';

export const CUSTOMER_PERMISSION_UPSERT = 'api/customers-column-permission/upsert';
export const CUSTOMER_PERMISSION_GET_BY_ROLE = 'api/customers-column-permission/get-by-role';


// --------- invioce -------
export const GET_ALL_INVIOCE = 'api/invoice-category/all';
export const DELETE_INVIOCE = 'api/invoice-category/delete';
export const UPDATE_INVIOCE = 'api/invoice-category/update';
export const CREATE_INVIOCE = 'api/invoice-category/create';


// --------- GET_INVIOCE_SUB_CATEGORY -------
export const GET_INVIOCE_SUB_CATEGORY = 'api/invoice-sub-category/all';
export const DELETE_SUB_INVIOCE = 'api/invoice-sub-category/delete';
export const CREATE_SUB_INVIOCE = 'api/invoice-sub-category/create';
export const UPDATE_SUB_INVIOCE = 'api/invoice-sub-category/update';
export const INVIOCE_SUB_CATEGORY_BI_ID = 'api/invoice-sub-category/get-by-category';

// --------- GET_PAYMENT_ALL -------
export const GET_PAYMENT_ALL = 'api/payment-merchant/all';
export const CREATE_PAYMENT = 'api/payment-merchant/create';
export const UPDATE_PAYMENT = 'api/payment-merchant/update';
export const DELETE_PAYMENT = 'api/payment-merchant/delete';


// --------- GET_STATUS_MASTER  -------
export const GET_STATUS_MASTER = 'api/status-master/all';
export const CREATE_STATUS_MASTER = 'api/status-master/create';
export const UPDATE_STATUS_MASTER = 'api/status-master/update';
export const DELETE_STATUS_MASTER = 'api/status-master/delete';

// --------- IP_ADDRESS  -------
export const GET_IP_ADDRESS = 'api/ip-whitelist/all';
export const CREATE_IP_ADDRESS = 'api/ip-whitelist/create';
export const UPDATE_IP_ADDRESS = 'api/ip-whitelist/update';
export const DELETE_IP_ADDRESS = 'api/ip-whitelist/delete';
export const CHECK_DEVICE_WHITELISTED = 'api/ip-whitelist/is-whitelisted';

// --------- GET_STATUS_MASTER  -------
export const GET_KNOWLEDGE_BASE = 'api/knowledge-base/all';
export const CREATE_KNOWLEDGE_BASE = 'api/knowledge-base/create';
export const UPDATE_KNOWLEDGE_BASE = 'api/knowledge-base/update';
export const DELETE_KNOWLEDGE_BASE = 'api/knowledge-base/delete';
export const GET_SINGLE_KNOWLEDGE_BASE = 'api/knowledge-base/get';


// --------- Chat   -------
export const GET_CHAT_HISTORY = 'api/chat-message/history';
export const GET_CHAT_USERS = 'api/chat-message/users';
export const SEND_MESSAGE = 'api/chat-message/send';
export const DELETE_MESSAGE = 'api/chat-message/delete';
export const ALL_CHAT_CONVERSATION = 'api/chat-message/all-conversations-for-admind';